import { Observable } from "rxjs/internal/Observable";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

    
    constructor(private authService: AuthService, private router: Router)  {

    }
    canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree>  {

  return this.checkAccess(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {

    return this.checkAccess(route, state);
  }

  private checkAccess(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {

  const isAdminOnlyRoute = route.pathFromRoot.some(r => r.data?.['adminOnly']);

  return this.authService.isAuthenticated().pipe(
    map(isAuth => {
      if (!isAuth) {
        return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
      }
      if (isAdminOnlyRoute && !this.authService.currentUser.isAdmin) {
        return this.router.createUrlTree(['/main']);
      }
      return true;
    })
  );
  }
}